import { useRouteError } from 'react-router-dom'
import EqxError from '../shared/components/EqxError'
import EqxIcon from '../shared/components/EqxIcon'
import { EqxLink } from '@equinoxx/react'

interface PageErrorProps {
    error?: string
}
const PageError = function (props: PageErrorProps) {
    const routeError = useRouteError() as { message: string } | undefined
    return <PageErrorNoRouting error={props.error ?? routeError?.message} />
}
const PageErrorNoRouting = function (props: PageErrorProps) {
    const error = props.error ?? 'An error occurred'
    return (
        <div className="text-center container">
            <div className="row">
                <div className="col-10 offset-1">
                    <h1 className="display-1">Page Error</h1>
                    <EqxError error={error} />
                    <EqxLink to="/" className="text-muted"><EqxIcon fa="fas fa-home" /> Home</EqxLink>
                </div>
            </div>
        </div>
    )
}

export { PageError as default, PageErrorNoRouting }

